import { Component } from '@angular/core';
import { AppSettings } from '../../../app.settings';

@Component({
	selector: 'anti-virus-security-info',
	template: require('./anti-virus-security-info.component.html'),
	host: { class: 'flex-column ' },
})
export class AntiVirusSecurityInfoComponent {
	public isRebrading = AppSettings.isRebrading;
	listOfBullets: string[] = [
		'Αυθεντικότητα των ιστοσελίδων της εθνικής Τράπεζας',
		'Ασφαλή επικοινωνία μέσω e-mail',
		'Πλοήγηση στο Internet',
		'Προστασία του υπολογιστή σας',
		'Ασφάλεια Συναλλαγών μέσω Internet, Phone και Mobile Banking',
	];
}
